module.exports = __webpack_public_path__ + "static/media/calderwood.d90afd43.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/assets/calderwood.png
// module id = 549
// module chunks = 0